if ( typeof MainHeader !== 'function' ) {

	class MainHeader extends HTMLElement {

		constructor(){
			super();
			this.mount();
		}

		mount(){

			/* -- > DRAWERS < -- */

			document.querySelectorAll('#main > div').forEach(elm=>{
				if ( ! elm.classList.contains('inert-inside') ) {
					elm.setAttribute('data-js-inert', '');
				}
			})
			window.inertElems = document.querySelectorAll('[data-js-inert]');

// Sticky Header GS 29.10.2024

if (this.hasAttribute('data-sticky-header')) {

    const stickyHeader = document.createElement('div');
    stickyHeader.classList.add('sticky-header');

    // Add the general structure for the sticky header
    stickyHeader.innerHTML = `<div class="header__bottom header-container container--large portable-hide">
        ${this.querySelector('.header__bottom').innerHTML}
    </div>
    <div class="site-header header__top container--large">
        ${this.querySelector('.header__top').innerHTML}
    </div>`;

    document.body.append(stickyHeader);

    stickyHeader.querySelectorAll('[id]').forEach(elm => {
        elm.id = `${elm.id}-sticky`;
    });

    // Function to apply desktop-specific styles to shift the sticky header and cart icon to the right
    function applyDesktopStyles() {
        if (window.innerWidth >= 1024) {
            // Desktop Styling: Apply padding to move header content to the right
            stickyHeader.style.position = 'fixed';
            stickyHeader.style.top = '0';
            stickyHeader.style.left = '0';
            stickyHeader.style.width = '100%';
            stickyHeader.style.zIndex = '1000';
            stickyHeader.style.backgroundColor = '#fff';
            stickyHeader.style.paddingLeft = '165px'; // Shift all header content to the right by adding padding
        } else {
            // Reset styles for mobile
            stickyHeader.style.position = '';
            stickyHeader.style.width = '';
            stickyHeader.style.backgroundColor = '';
            stickyHeader.style.paddingLeft = ''; // Reset padding for mobile
        }
    }

    // Apply styles initially and on window resize
    applyDesktopStyles();
    window.addEventListener('resize', applyDesktopStyles);

    // Add icons only for desktop (check window width)
    if (window.innerWidth >= 1024) {
        // Create a container for the account, cart, and search icons (keeping them together)
        const iconsContainer = document.createElement('div');
        iconsContainer.classList = 'sticky-icons';
        iconsContainer.style.display = 'flex';
        iconsContainer.style.alignItems = 'center';
        iconsContainer.style.gap = '20px';
        iconsContainer.style.marginRight = '20px';
        iconsContainer.style.background = 'none'; // Ensure no background color

       // Create the search icon element
const searchIconLink = document.createElement('a');
searchIconLink.href = "";
searchIconLink.classList.add('search-link');
searchIconLink.style.display = 'flex';
searchIconLink.style.alignItems = 'center';
searchIconLink.style.textDecoration = 'none';
searchIconLink.style.background = 'none'; // Ensure no background
searchIconLink.style.border = 'none';
searchIconLink.style.padding = '0';

// Add SVG icon directly as innerHTML
searchIconLink.innerHTML = `
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="10.5" cy="10.5" r="7.5" stroke="black" stroke-width="2" style="fill:none!important"/>
        <path d="M17.1213 15.2929L16.4142 14.5858L15 16L15.7071 16.7071L17.1213 15.2929ZM19.2426 20.2426C19.6331 20.6332 20.2663 20.6332 20.6568 20.2426C21.0473 19.8521 21.0473 19.219 20.6568 18.8284L19.2426 20.2426ZM15.7071 16.7071L19.2426 20.2426L20.6568 18.8284L17.1213 15.2929L15.7071 16.7071Z" fill="black" style="stroke:none!important"/>
    </svg>
`;

document.body.appendChild(searchIconLink);

// Append the link to the container
iconsContainer.appendChild(searchIconLink);

       // Add the account icon to the container
const accountIconLink = document.createElement('a');
accountIconLink.href = "https://shopify.com/authentication/89235489093/login?client_id=ba3f2513-1063-4a48-97d7-0ab43c775543&locale=de&redirect_uri=https%3A%2F%2Fshopify.com%2Fauthentication%2F89235489093%2Foauth%2Fauthorize%3Fclient_id%3Dba3f2513-1063-4a48-97d7-0ab43c775543%26locale%3Dde%26nonce%3Df88a48c8-1d55-4dba-b7e2-0ddeb363ef36%26redirect_uri%3Dhttps%253A%252F%252Faccount.lemke-shop.de%252Fcallback%253Fsource%253Dcore%26response_type%3Dcode%26scope%3Dopenid%2Bemail%2Bcustomer-account-api%253Afull%26state%3D01JJ94V0RRS8T9GFF10ZD704CQ";
accountIconLink.classList.add('account-link');
accountIconLink.style.display = 'flex';
accountIconLink.style.alignItems = 'center';
accountIconLink.style.textDecoration = 'none';
accountIconLink.style.background = 'none'; // Ensure link has no background
accountIconLink.style.border = 'none';
accountIconLink.style.padding = '0';

// Add SVG icon directly as innerHTML
accountIconLink.innerHTML = `
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18.3333 19.25V17.4167C18.3333 16.4442 17.947 15.5116 17.2593 14.8239C16.5717 14.1363 15.6391 13.75 14.6666 13.75H7.33329C6.36083 13.75 5.4282 14.1363 4.74057 14.8239C4.05293 15.5116 3.66663 16.4442 3.66663 17.4167V19.25" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="fill:none!important"/>
        <path d="M11 10.0833C13.0251 10.0833 14.6667 8.44171 14.6667 6.41667C14.6667 4.39162 13.0251 2.75 11 2.75C8.975 2.75 7.33337 4.39162 7.33337 6.41667C7.33337 8.44171 8.975 10.0833 11 10.0833Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="fill:none!important"/>
    </svg>
`;

// Append the link to the icons container
iconsContainer.appendChild(accountIconLink);


       // Add the cart icon to the container
const cartIconLink = document.createElement('a');
cartIconLink.setAttribute('data-spark-link', 'cart'); // Link to header.js cart logic
cartIconLink.style.display = 'flex';
cartIconLink.style.alignItems = 'center';
cartIconLink.style.textDecoration = 'none';
cartIconLink.style.background = 'none'; // Ensure link has no background
cartIconLink.style.border = 'none';
cartIconLink.style.padding = '0';

// Insert SVG directly as innerHTML
cartIconLink.innerHTML = `
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-left:-2px">
        <path class="circle" d="M9.5 20C9.77614 20 10 19.7761 10 19.5C10 19.2239 9.77614 19 9.5 19C9.22386 19 9 19.2239 9 19.5C9 19.7761 9.22386 20 9.5 20Z" fill="none" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path class="circle" d="M18.5 20C18.7761 20 19 19.7761 19 19.5C19 19.2239 18.7761 19 18.5 19C18.2239 19 18 19.2239 18 19.5C18 19.7761 18.2239 20 18.5 20Z" fill="black" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M3 3H6.27273L8.46545 13.7117C8.54027 14.08 8.7452 14.4109 9.04436 14.6464C9.34351 14.8818 9.71784 15.0069 10.1018 14.9997H18.0545C18.4385 15.0069 18.8129 14.8818 19.112 14.6464C19.4112 14.4109 19.6161 14.08 19.6909 13.7117L21 6.9999H7.09091" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="fill:none !important"/>
    </svg>
`;


// Add cart count
const cartCount = document.createElement('span');
cartCount.classList.add('cart-count');
cartCount.textContent = '(0)'; // Default value, updated dynamically below
cartCount.style.marginLeft = '5px';
cartCount.style.fontSize = '14px';
cartCount.style.color = '#000';

// Append SVG and cart count to cart icon link
cartIconLink.appendChild(cartCount);
iconsContainer.appendChild(cartIconLink);

// Add the icons container to the sticky header (only for desktop)
stickyHeader.querySelector('.header__bottom').appendChild(iconsContainer);

// Add event listener to open the cart sidebar in the main header when clicking the sticky cart icon
cartIconLink.addEventListener('click', function(event) {
    event.preventDefault();

    // Trigger the cart sidebar open action in the main header
    const cartButton = document.querySelector('[data-js-sidebar-handle]');
    if (cartButton) {
        cartButton.click(); // Trigger the click event to open the cart sidebar
    } else {
        console.error('Cart sidebar handle not found.');
    }
});


        // Add event listener to focus search input in the main header when clicked
        searchIconLink.addEventListener('click', function(event) {
            event.preventDefault();
            let attempts = 5;

            function focusSearchInput() {
                const mainSearchInput = document.querySelector('input[type="search"]');

                if (mainSearchInput) {
                    mainSearchInput.focus();
                    mainSearchInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
                } else if (attempts > 0) {
                    attempts--;
                    setTimeout(focusSearchInput, 100);
                } else {
                    console.error('Could not find the main search input field after multiple attempts.');
                }
            }

            focusSearchInput();
        });

        // Function to update cart count dynamically from Shopify's cart API
        function updateCartCount() {
            fetch('/cart.js')
                .then(response => response.json())
                .then(cart => {
                    if (cart && cart.item_count !== undefined) {
                        cartCount.textContent = `(${cart.item_count})`;
                    }
                })
                .catch(error => {
                    console.error('Error fetching cart data:', error);
                });
        }

        // Update the cart count initially and every time the page loads
        document.addEventListener('DOMContentLoaded', () => {
            updateCartCount();
        });

        // Refresh the cart count more frequently (every 5 seconds)
        setInterval(updateCartCount, 5000); // Refresh cart count every 5 seconds

        // Listen for cart changes using Shopify's Ajax API
        document.addEventListener('cart:updated', updateCartCount);

        // Trigger updateCartCount when items are added to the cart using the Ajax API
        document.addEventListener('click', (event) => {
            if (event.target.closest('form[action="/cart/add"]') || event.target.closest('.cart-remove')) {
                updateCartCount(); // Trigger an immediate cart count update
            }
        });

        // Use mutation observer to monitor DOM changes and update cart count faster
        const observer = new MutationObserver(() => {
            updateCartCount();
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });
    }

    // Keep the rest of the sticky header code as is, to maintain functionality
    window.lst = window.scrollY;
    window.lhp = 0;

    const stickyHeaderDeskBound = this.querySelector('.header__bottom');
    const stickyHeaderMobileBound = this.querySelector('.header__top');

    this.SCROLL_StickyHelper = () => {
        var isMobile = !(window.innerWidth >= 1024);
        var st = window.scrollY;

        if ((st <= 0 || (window.innerWidth >= 1024 ? stickyHeaderDeskBound.getBoundingClientRect().top >= 0 : stickyHeaderMobileBound.getBoundingClientRect().top >= 0)) && stickyHeader.classList.contains('show')) {
            stickyHeader.classList.remove('show');
            return;
        } else if (!isMobile) {
            window.lhp = stickyHeader.offsetTop;
            if ((window.innerWidth >= 1024 ? stickyHeaderDeskBound.getBoundingClientRect().top : stickyHeaderMobileBound.getBoundingClientRect().top) < -100) {
                stickyHeader.classList.add('show');
            }
        }

        if (st < 0 || Math.abs(window.lst - st) <= 5)
            return;

        if (isMobile) {
            if (st > window.lhp) {
                if (st == 0 && stickyHeader.classList.contains('show')) {
                    stickyHeader.classList.remove('show');
                } else if (st <= window.lst && !stickyHeader.classList.contains('show')) {
                    window.lhp = stickyHeader.offsetTop;
                    if ((window.innerWidth >= 1024 ? stickyHeaderDeskBound.getBoundingClientRect().top : stickyHeaderMobileBound.getBoundingClientRect().top) < -100) {
                        stickyHeader.classList.add('show');
                    }
                } else if (st > window.lst && stickyHeader.classList.contains('show')) {
                    stickyHeader.classList.remove('show');
                }
            }
            window.lst = st;
        }
    };

    window.addEventListener('scroll', this.SCROLL_StickyHelper, { passive: true });

    stickyHeader.querySelectorAll('.submenu-masonry').forEach(elm => {
        if (Macy) {
            const submenuMacy = new Macy({
                container: elm,
                columns: elm.classList.contains('with-promotion') ? 3 : 4
            });
            setTimeout(() => {
                submenuMacy.reInit();
            }, 100);
        }
    });
}
// END GS 29.10.2024

			// drawer cart connections

			document.querySelectorAll('[data-js-sidebar-handle]').forEach(elm => {
				if ( elm.hasAttribute('aria-controls') ) {
					const elmSidebar = document.getElementById(elm.getAttribute('aria-controls'));
					elm.addEventListener('click', e=>{
						e.preventDefault();
						elm.setAttribute('aria-expanded', 'true');
						elmSidebar.show();
					})
					elm.addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							elm.setAttribute('aria-expanded', 'true');
							elmSidebar.show();
							elmSidebar.querySelector('[data-js-close]').focus();
						}
					})
				}
			})
			
			// closing drawers

			document.querySelectorAll('sidebar-drawer [data-js-close]').forEach(elm=>{
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( e.target.closest('.sidebar').classList.contains('sidebar--opened') ) {
						e.target.closest('.sidebar').hide();
					}
				});
			});
			document.querySelector('.site-overlay').addEventListener('click', ()=>{
				if ( document.querySelector('.sidebar--opened') ) {
					document.querySelector('.sidebar--opened').hide();
				}
			});
			document.addEventListener('keydown', e=>{
				if ( e.keyCode == window.KEYCODES.ESC ) {
					if ( document.querySelector('.sidebar--opened') ) {
						document.querySelector('.sidebar--opened').hide();
					}
				}
			});

			// resizing drawers

			const rootHeight = document.getElementById('root-height');
			this.RESIZE_SidebarHelper = debounce(()=>{
				rootHeight.innerHTML = `:root {
					--window-height: ${window.innerHeight}px;
				}`;
			}, 200);
			window.addEventListener('resize', this.RESIZE_SidebarHelper);
			rootHeight.innerHTML = `:root {
				--window-height: ${window.innerHeight}px;
			}`;

			// Init modal windows

			document.querySelectorAll('[aria-controls="modal-store-selector"]').forEach(elm=>{
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( document.querySelector('.sidebar--opened') ) {
						document.querySelector('.sidebar--opened').hide();
					}
					if ( document.getElementById(elm.getAttribute('aria-controls')) ) {
						document.getElementById(elm.getAttribute('aria-controls')).show();
					}
				})
				elm.addEventListener('keyup', e=>{
					if ( e.keyCode == window.KEYCODES.RETURN ) {
						if ( document.querySelector('.sidebar--opened') ) {
							document.querySelector('.sidebar--opened').hide();
						}
						if ( document.getElementById(elm.getAttribute('aria-controls')) ) {
							document.getElementById(elm.getAttribute('aria-controls')).show();
						}
					}
				})
			});

			// Submenu alignment

			const rtl = document.documentElement.getAttribute('dir') == 'rtl';
			document.querySelectorAll('.site-nav.style--classic .has-submenu').forEach(elm=>{
				elm.addEventListener('mouseover', ()=>{
					if ( elm.querySelector('.normal-menu') ) {
						elm.querySelector('.normal-menu').style.left = `${rtl ? elm.getBoundingClientRect().right : elm.getBoundingClientRect().left}px`;
					}
				})
			})

			// predictive search

			if ( JSON.parse(document.getElementById('shopify-features').text).predictiveSearch ) {
				document.querySelectorAll('search-form [data-js-search-input]').forEach(elm=>{
					elm.addEventListener('focus', ()=>{
						document.getElementById(elm.dataset.jsFocusOverlay).classList.add('active');
						if ( ! document.body.classList.contains('predictive-script-loaded') ) {
							document.body.classList.add('predictive-script-loaded')
							const predictiveSearchJS = document.createElement('script');
							predictiveSearchJS.src = KROWN.settings.predictive_search_script;
							document.head.appendChild(predictiveSearchJS); 
						}
					})
					elm.addEventListener('keydown', e=>{
						if ( e.keyCode == window.KEYCODES.TAB ) {
							if ( document.getElementById('search-results-overlay-desktop').classList.contains('active') ) {
								document.getElementById('search-results-overlay-desktop').classList.remove('active');
							}
						}
					})
				})
				window.addEventListener('load', ()=>{
					document.querySelectorAll('.search-results-overlay').forEach(elm=>{
						elm.style = '';
					})
				});
			} else {
				document.querySelector('search-form [data-js-search-input] + button').classList.add('button--invisibile-trigger');
			}

			// touch navigation for the menu

			const closeTouchSubmenus = (focusedElm, focusedParent=null)=>{
				document.querySelectorAll('.style--classic li.focus').forEach(elm=>{
					if ( ! ( elm === focusedElm || elm === focusedParent ) ) {
						elm.classList.remove('focus');
					}
				})
			}
			let babyMenuTouch = false;
			document.querySelectorAll('.style--classic .has-babymenu').forEach(elm=>{
				elm.addEventListener('touchstart', e=>{
					elm.firstElementChild.style.pointerEvents = 'none';
					elm.classList.toggle('focus');
					babyMenuTouch = true;
					closeTouchSubmenus(elm,elm.closest('.has-submenu'));
				})
			})
			document.querySelectorAll('.style--classic .has-submenu').forEach(elm=>{
				if ( ! elm.classList.contains('mega-link') ) {
					elm.addEventListener('touchstart', e=>{
					elm.firstElementChild.style.pointerEvents = 'none';
					if ( ! babyMenuTouch ) {
						elm.classList.toggle('focus');
						closeTouchSubmenus(elm);
					}
						babyMenuTouch = false;
					})
				}
			})

			// tab navigation for the menu

			document.querySelectorAll('.site-nav.style--classic .has-submenu > a').forEach(childEl=>{

				const elm = childEl.parentNode;

				elm.addEventListener('keydown', e=>{

					if ( e.keyCode == window.KEYCODES.RETURN ) {
						if ( ! e.target.classList.contains('no-focus-link') ) {
							e.preventDefault();
						}
						if ( ! elm.classList.contains('focus') ) {
							elm.classList.add('focus');
							elm.setAttribute('aria-expanded', 'true');
						} else if ( document.activeElement.parentNode.classList.contains('has-submenu') && elm.classList.contains('focus') ) {
							elm.classList.remove('focus');
							elm.setAttribute('aria-expanded', 'true');
						}
					}
				});	
				
				if ( elm.querySelector('.submenu-holder > li:last-child a') ) {
					elm.querySelector('.submenu-holder > li:last-child a').addEventListener('focusout', e=>{
						if ( elm.classList.contains('focus') ) {
							elm.classList.remove('focus');
							elm.setAttribute('aria-expanded', 'false');
						}
					});
				}

			});

			document.querySelectorAll('.site-nav.style--classic .has-babymenu:not(.mega-link) > a').forEach(childEl=>{	

				const elm = childEl.parentNode;

				elm.addEventListener('keydown', e=>{
					if ( e.keyCode == window.KEYCODES.RETURN ) {
						if ( ! e.target.classList.contains('no-focus-link') ) {
							e.preventDefault();
						}
						if ( ! elm.classList.contains('focus') ) {
							elm.classList.add('focus');
							elm.setAttribute('aria-expanded', 'true');
						} else {
							elm.classList.remove('focus');
							elm.setAttribute('aria-expanded', 'false');
						}
					}
				});

				if ( elm.querySelector('.babymenu li:last-child a') ) {
					elm.querySelector('.babymenu li:last-child a').addEventListener('focusout', e=>{
						if ( elm.parentNode.classList.contains('focus') ) {
							elm.parentNode.classList.remove('focus');
							elm.parentNode.setAttribute('aria-expanded', 'false');
						}
					});
				}

			})

		}

		unmount(){
			window.removeEventListener('resize', this.RESIZE_SidebarHelper);
		}

	}
	
  if ( typeof customElements.get('main-header') == 'undefined' ) {
		customElements.define('main-header', MainHeader);
	}

}

if ( typeof SidebarDrawer !== 'function' ) {

	class SidebarDrawer extends HTMLElement {

		constructor(){
			super();
			this.querySelector('[data-js-close]').addEventListener('click', ()=>{
				this.hide();
			});
			document.addEventListener('keydown', e=>{
				if ( e.keyCode == window.KEYCODES.ESC ) {
					const openedSidebar = document.querySelector('sidebar-drawer.sidebar--opened');
					if ( openedSidebar ){
						openedSidebar.hide();
					}
				}
			});
		}

		/* 
			* generic hide/show functions 
		*/

		show(){

			this.opened = true;
			document.body.classList.add('sidebar-opened');
			if ( this.classList.contains('sidebar--right') ) {
				document.body.classList.add('sidebar-opened--right');
			} else if ( this.classList.contains('sidebar--left') ) {
				document.body.classList.add('sidebar-opened--left');
			}
			this.style.display = 'grid';
			setTimeout(()=>{
				this.classList.add('sidebar--opened');
				window.inertElems.forEach(elm=>{
					elm.setAttribute('inert', '');
				})
			}, 15);
			if ( this.id == "site-cart-sidebar" ) {
				if ( document.querySelector('#cart-recommendations css-slider') ) {
					document.querySelector('#cart-recommendations css-slider').resetSlider();
				}
			}

		}

		hide(){

			this.opened = false;
			this.classList.remove('sidebar--opened');

			document.body.classList.remove('sidebar-opened');
			document.body.classList.remove('sidebar-opened--left');
			document.body.classList.remove('sidebar-opened--right');
			window.inertElems.forEach(elm=>{
				elm.removeAttribute('inert');
			})

			document.querySelector(`[aria-controls="${this.id}"]`).setAttribute('aria-expanded', 'false');

			setTimeout(()=>{
				this.style.display = 'none';
			}, 501);

		}

	}


  if ( typeof customElements.get('sidebar-drawer') == 'undefined' ) {
		customElements.define('sidebar-drawer', SidebarDrawer);
	}

}

if ( typeof MobileNavigation !== 'function' ) {
		
	class MobileNavigation extends HTMLElement {

		constructor() {

			super();

			this._openedFirstSubmenu = false;
			this._openedSecondSubmenu = false;

			this.querySelectorAll('.has-submenu > a').forEach(elm=>{
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( ! this._openedFirstSubmenu ) {
						this._openedFirstSubmenu = true;
						this.classList.add('opened-first-submenu');
						this.closest('sidebar-drawer').scrollTo({top: 0});
					}
					e.target.closest('li').classList.add('opened');
					this._resizeContainer();
				})
			});

			this.querySelectorAll('.has-babymenu > a').forEach(elm=>{
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( ! this._openedSecondSubmenu ) {
						this._openedSecondSubmenu = true;
						this.classList.add('opened-second-submenu');
						this.closest('sidebar-drawer').scrollTo({top: 0});
					}
					e.target.closest('li').classList.add('opened');
					this._resizeContainer();
				})
			});

			this.querySelectorAll('.submenu-back a').forEach(elm=>{
				elm.addEventListener('click', e=>{
					if ( this._openedSecondSubmenu ) {
						this._openedSecondSubmenu = false;
						this.classList.remove('opened-second-submenu');
						this._resizeContainer();
					} else if ( this._openedFirstSubmenu ) {
						this._openedFirstSubmenu = false;
						this.classList.remove('opened-first-submenu');
						this._resizeContainer(true);
					}
					this.closest('sidebar-drawer').scrollTo({top: 0});
					setTimeout(()=>{
						e.target.closest('li.opened').classList.remove('opened');
					}, 301);
					e.preventDefault();
				})
			});

			if ( this.dataset.showHeaderActions == 'true' ) {

				const mobileNavActions = document.createElement('div');
				mobileNavActions.classList = "header-actions flex-buttons";
				mobileNavActions.innerHTML = document.querySelector('[data-js-header-actions]').innerHTML;
				this.querySelector('nav').prepend(mobileNavActions);

				mobileNavActions.querySelectorAll('[id]').forEach(elm=>{
					elm.id = `${elm.id}-mobile`;
				});
				
				mobileNavActions.querySelectorAll('[data-modal]').forEach(elm=>{
					elm.addEventListener('click', e=>{
						e.preventDefault();
						if ( document.querySelector('.sidebar--opened') ) {
							document.querySelector('.sidebar--opened').hide();
						}
						if ( document.getElementById(elm.getAttribute('aria-controls')) ) {
							document.getElementById(elm.getAttribute('aria-controls')).show();
						}
					})
				});
				
			}

		}

		_resizeContainer(main=false){
      if ( main ) {
				this.style.height = `auto`;
      } else {
				if ( this._openedSecondSubmenu ) {
					this.style.height = `${this.querySelector('.has-babymenu.opened .babymenu').scrollHeight}px`;
				} else if ( this._openedFirstSubmenu ) {
					this.style.height = `${this.querySelector('.has-submenu.opened .submenu').scrollHeight}px`;
				}  
      }
		}

	}

  if ( typeof customElements.get('mobile-navigation') == 'undefined' ) {
		customElements.define('mobile-navigation', MobileNavigation);
	}

}

if ( typeof ScrollableNavigation !== 'function' ) {

	class ScrollableNavigation extends HTMLElement {

		constructor() {

			super();

			this.linkList = this.querySelector('.link-list');
			this.header = this.parentNode;
			window.addEventListener('resize', debounce(()=>{
				this.checkNav();
			}, 200));
			this.checkNav();

			const rtl = document.documentElement.getAttribute('dir') == 'rtl';

			this.parentNode.querySelector('.scrollable-navigation-button--left').addEventListener('click', ()=>{
				this.scroll({
					top: 0,
					left: this.scrollLeft - (rtl ? -100 : 100),
					behavior: 'smooth'
				});
			})
			this.parentNode.querySelector('.scrollable-navigation-button--right').addEventListener('click', ()=>{
				this.scroll({
					top: 0,
					left: this.scrollLeft + (rtl ? -100 : 100),
					behavior: 'smooth'
				});
			})

		}

		checkNav() {
			if ( this.linkList.scrollWidth > this.offsetWidth ) {
				this.header.classList.add('scrolling-navigation-enabled');
			} else {
				this.header.classList.remove('scrolling-navigation-enabled');
			}
		}
		
	}

  if ( typeof customElements.get('scrollable-navigation') == 'undefined' ) {
		customElements.define('scrollable-navigation', ScrollableNavigation);
	}

}